export const availableStates = {
  0: "offline",
  1: "available",
  2: "reserved",
  3: "fault",
  4: "unavailable",
  5: "operator",
  6: "self_check",
  7: "firmware_update",
  8: "out_of_service",
  9: "charging",
  999: "mismatched",
};

export const deploymentStatuses = ["in_field", "warehouse", "decommissioned"];

export const possessionStatuses = [
  "in_possession",
  "inaccessible",
  "missing",
  "lost",
  "in_transit",
  "govt_partnerships",
  "engineering",
];

export const provisioningStatuses = ["unprovisioned", "in_progress", "provisioned"];

export const JUMIO_LEVELS = ["none", "fast_fill", "jumio_go", "jumio_go_with_selfie"];

export const CURRENCIES = [
  "USD", // US dollar
  "EUR", // Euro
  "GBP", // GB pound
  "SEK", // Swedeish krona
  "TRY", // Turkish lira
  "CAD", // Canadian dollar
  "CHF", // Swiss Frank
  "NOK", // Norwegian Kroner
];

export const USD_CONVERSIONS = {
  // at the point we're doing anything beyond crude form validation
  // we should start using an actual currency conversion api,
  // relayed to us via billing
  // updated 2/28/2022 using google converter widget
  USD: 1,
  EUR: 0.94,
  GBP: 0.83,
  SEK: 10.45,
  TRY: 18.88,
  CAD: 1.36,
  CHF: 0.94,
  NOK: 0.92,
};

export const taxNames = ["Sales Tax", "Including VAT"];

export const taxTypes = ["exclusive", "inclusive"];

export const feeTypes = ["fixed", "percentage"];

export const FLEET_SETTING_PAGES = ["general", "billing", "passes", "messaging"];

export const UNITED_STATES_NAMES = ["us", "usa", "united states", "united states of america"];

export const NUM_STRING_FORMATS = [...CURRENCIES, "PERCENT_WHOLE", "DECIMAL", "MINUTES"];

export const PROMO_CODE_TYPES = ["discount", "bonus", "unlock"];

export const PROMO_GROUP_TYPES = ["discount", "bonus", "unlock"];

export const GEOFENCE_SCHEDULE_TYPES = {
  doesNotRepeat: "Does not Repeat",
  datesOfMonth: "Dates of Month",
  dayOfWeek: "Day of Week",
  weekly: "Weekly",
};

export const TWENTY_FOUR_HOURS_IN_MINUTES = 24 * 60;

export const MONTHS_OF_YEAR = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const ABBREVIATED_MONTHS_OF_YEAR = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const MONTHS_IN_DIGITS = {
  january: 1,
  february: 2,
  march: 3,
  april: 4,
  may: 5,
  june: 6,
  july: 7,
  august: 8,
  september: 9,
  october: 10,
  november: 11,
  december: 12,
};

export const ABBREVIATED_MONTHS = {
  january: "Jan",
  february: "Feb",
  march: "Mar",
  april: "Apr",
  may: "May",
  june: "Jun",
  july: "Jul",
  august: "Aug",
  september: "Sep",
  october: "Oct",
  november: "Nov",
  december: "Dec",
};

export const ABBREVIATED_DAYS = {
  sunday: "Sun",
  monday: "Mon",
  tuesday: "Tue",
  wednesday: "Wed",
  thursday: "Thu",
  friday: "Fri",
  saturday: "Sat",
};

export const DAYS_OF_WEEK = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const ABBREVIATED_DAYS_OF_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const GeofencesLayerTypes = Object.freeze({
  none: "none",
  operationalZone: "is_operational_zone",
  warehouse: "warehouse",
  noParkingZone: "no_parking_zone",
  noScooterZone: "no_scooter_zone",
  noRidingZone: "no_riding_zone",
  slowRidingZone: "slow_riding_zone",
  noParkingSlowZone: "no_parking_slow_zone",
  parkingAllowedZone: "allow_parking_zone",
  parkingLimitedZone: "limited_parking_zone",
  parkingIncentivizedZone: "parking_incentive_zone",
});

export const GeofencesHollowLayers = [
  GeofencesLayerTypes.operationalZone,
  GeofencesLayerTypes.parkingLimitedZone,
];

export const GeofencesSpeedLayers = [
  GeofencesLayerTypes.operationalZone,
  GeofencesLayerTypes.slowRidingZone,
  GeofencesLayerTypes.noParkingSlowZone,
];

export const GeofencesIncentiveLayers = [GeofencesLayerTypes.parkingIncentivizedZone];
export const GeofencesLayersToFill = [
  GeofencesLayerTypes.parkingAllowedZone,
  GeofencesLayerTypes.parkingIncentivizedZone,
];

export const SidewalksLayers = [
  GeofencesLayerTypes.none,
  GeofencesLayerTypes.noRidingZone,
  GeofencesLayerTypes.slowRidingZone,
];

export const GeofencesSpeedDimensions = Object.freeze({
  km: { key: "km", value: "km/h" },
  mi: { key: "mi", value: "mi/h" },
});

export const GeofencesPanelPositions = Object.freeze({
  LEFT: "left",
  TOP: "top",
});

export const GeofencesEditModes = Object.freeze({
  default: "DEFAULT",
  polygonCreate: "POLYGON_CREATE",
  polygonEdit: "POLYGON_EDIT",
  hex: "HEX",
  hexBrush: "HEX_BRUSH",
});

export const GeofencesResolutionRange = Object.freeze({
  min: 1,
  max: 12,
  default: 12,
  maxSidewalks: 15,
  defaultSidewalks: 15,
});

export const GeofencesChildrenThresholdRange = Object.freeze({
  min: 1,
  max: 7,
  default: 4,
});

export const GeofencesSpeedRange = Object.freeze({
  min: 0,
  max: 25,
  default: 15,
});

export const GeofencesIncentiveRange = Object.freeze({
  min: 1,
  default: null,
});

export const HexBrushModes = Object.freeze({
  add: "ADD",
  remove: "REMOVE",
});

export const GeofencesThresholds = Object.freeze({
  [GeofencesLayerTypes.none]: GeofencesChildrenThresholdRange.min,
  [GeofencesLayerTypes.operationalZone]: GeofencesChildrenThresholdRange.min,
  [GeofencesLayerTypes.warehouse]: GeofencesChildrenThresholdRange.min,
  [GeofencesLayerTypes.noParkingZone]: GeofencesChildrenThresholdRange.max,
  [GeofencesLayerTypes.noScooterZone]: GeofencesChildrenThresholdRange.max,
  [GeofencesLayerTypes.noRidingZone]: GeofencesChildrenThresholdRange.max,
  [GeofencesLayerTypes.slowRidingZone]: GeofencesChildrenThresholdRange.max,
  [GeofencesLayerTypes.noParkingSlowZone]: GeofencesChildrenThresholdRange.max,
  [GeofencesLayerTypes.parkingAllowedZone]: GeofencesChildrenThresholdRange.min,
  [GeofencesLayerTypes.parkingLimitedZone]: GeofencesChildrenThresholdRange.max,
  [GeofencesLayerTypes.parkingIncentivizedZone]: GeofencesChildrenThresholdRange.min,
});

export const GeofencesExportOptions = Object.freeze({
  GeoJSON: "GeoJSON",
  FleetSpecificJSON: "FleetSpecificJSON",
  FleetAgnosticJSON: "FleetAgnosticJSON",
  GeofenceBinaryPreview: "GeofenceBinaryPreview",
  GeofenceBinaryUpload: "GeofenceBinaryUpload",
});

export const SidewalkExportOptions = Object.freeze({
  GeoJSON: "GeoJSON",
  FleetSpecificJSON: "FleetSpecificJSON",
  FleetAgnosticJSON: "FleetAgnosticJSON",
});

export const MaxConcurrentRequests = 5;

export const MaxMapZoom = 22;
export const MinVisibleHexesZoom = 19;

export const ErrorVisibilityDuration = 10000;

export const PassOfferConstants = {
  PASS_OFFER_TYPE_ID: "pass_offer_type_id",
  LINKUP: "linkup",
  DAILY: "daily",
};

export const DepositTransactionTypes = [
  "AUTO_TRIP_CREDIT",
  "BANK_TRANSFER",
  "BONUS_COUPON",
  "BONUS_DEPOSIT",
  "FIRST_CARD_BONUS",
  "PARKING_INCENTIVE_BONUS",
  "PAY_OFF_DEBT",
  "TRIP_CREDIT",
  "TRIP_DEBT_REDUCTION",
  "ZERO_OUT",
  "PASS_CASH_OUT",
  "UNKNOWN",
];

export const DebitTransactionTypes = [
  "BONUS_DEBIT",
  "DEPOSIT_CASH_OUT",
  "CARD_HOLD",
  "CARD_HOLD_REUSE",
  "CARD_AUTHORIZATION",
  "CARD_VALIDATION",
  "TRIP_PAYMENT",
  "TRIP_PAYMENT_DEBT",
  "TRIP_WALLET_PAYMENT",
  "PASS_PURCHASE",
  "TRIP_PAYMENT_CASH_OUT",
];

export const TransactionsTypesForCashout = [
  "BANK_TRANSFER",
  "TRIP_PAYMENT",
  "CARD_HOLD",
  "RETRY_PAYMENT",
  "CARD_HOLD_REUSE",
  "FINE_CHARGE",
];

export const CashOutTransactions = ["PASS_CASH_OUT", "DEPOSIT_CASH_OUT"];

export const ClusterNames = {
  Staging: "Staging",
  Link: "Link",
  EU: "EU",
};

export const ACCOUNT_STATUS = {
  Active: "Active",
  Suspended: "Suspended",
  Banned: "Banned",
  Deleted: "Deleted",
};

export const BANS_AND_SUSPENSION_REASON = {
  parking_violation: "parking_violation",
  riding_violation: "riding_violation",
  vandalism: "vandalism",
  "t&c_violation": "t&c_violation",
  fraud: "fraud",
  other: "other",
};

export const commandHistoryDetailFields = [
  "options",
  "rpc_msg_id",
  "rpc_payload",
  "rx_from",
  "result_info",
];

export const MONTHS_OF_YEAR_MAP = {
  january: 0,
  february: 1,
  march: 2,
  april: 3,
  may: 4,
  june: 5,
  july: 6,
  august: 7,
  september: 8,
  october: 9,
  november: 10,
  december: 11,
};

export const DAYS_OF_WEEK_MAP = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

export const HIGHEST_COMPLETED_JUMIO_LEVEL = "jumio_go_with_selfie";

export const JUMIO_LEVELS_MAP = {
  none: "Incomplete",
  fast_fill: "Fast Fill",
  jumio_go: "Jumio Go",
  jumio_go_with_selfie: "Jumio Go with Selfie",
};

export const DEFAULT_PSP_ICON = "spwallet";

export const PSP = {
  braintree: "braintree",
  payments_os: "payments_os",
  paypal: "paypal",
  stripe: "stripe",
};

export const PLATFORM_CHOICES = ["SUPERPEDESTRIAN", "ATOM", "GO_X", "ATOM_testing"];
export const PLATFORM_LABELS = { SUPERPEDESTRIAN: "Superpedestrian", ATOM: "Atom", GO_X: "Go-X", ATOM_testing: "ATOM_testing" };

// Note: FLEET_GROUP_CHOICES should match those defined on the vehicle-api fleet model
// See: https://github.com/Superpedestrian/sp-web-vehicle-api/blob/main/vehicle_api/models/fleet.py#L49-L55
export const FLEET_GROUP_CHOICES = {
  CANADA: "Canada",
  US_OPS_TOTAL: "US Ops Total",
  EU_OPS_TOTAL: "EU Ops Total",
  OTHER: "Other",
  NON_REVENUE: "Non-Revenue Generating",
};

export const SURVEY_REPEAT_CONDITIONS = [
  "only_rides",
  "only_days",
  "rides_or_days",
  "do_not_repeat",
];

export const HibernationSteps = Object.freeze({
  selectType: 0,
  uploadCsv: 1,
  summarizeCsv: 2,
  confirm: 3,
});
export const HibernationTypes = Object.freeze({
  partial: "partial",
  full: "full",
});

export const scooterTypes = Object.freeze({
  GALAXY: "Galaxy",
  MAYFLOWER: "Mayflower",
  MIXED: "Mixed",
  UNKNOWN: "Unknown",
});

export const VEHICLE_POINT_OVERLAP_AREA = 0.00005;
